module.exports = __webpack_public_path__ + "img/television.8a5eaa5c.svg";